import React from 'react';
import SectionContainer from './SectionContainer';
import MetricDisplay from './MetricDisplay';
import TrendChart from './TrendChart';

function InfrastructureSection({ data, nationalAvg, utilityData, selectedYear }) {
  if (!data) {
    return (
      <SectionContainer icon="&#x1F527;" title="Infrastructure & Innovation">
        <p className="text-sm text-gray-400">No infrastructure data available</p>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer icon="&#x1F527;" title="Infrastructure & Innovation">
      <div className="space-y-1 divide-y divide-gray-100">
        <MetricDisplay
          label="AMI Deployment"
          value={data.ami_deployment_pct}
          unit="%"
          nationalAvg={nationalAvg?.ami_deployment_pct}
          lowerIsBetter={false}
          precision={1}
        />
      </div>

      {/* Meter counts */}
      {data.ami_meters && data.total_meters && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          <h4 className="text-xs font-medium text-gray-500 uppercase mb-2">Meter Details</h4>
          <div className="space-y-1">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Smart Meters (AMI)</span>
              <span className="text-gray-700">{data.ami_meters?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Total Meters</span>
              <span className="text-gray-700">{data.total_meters?.toLocaleString()}</span>
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-3">
            <div className="flex justify-between text-xs text-gray-500 mb-1">
              <span>AMI Deployment Progress</span>
              <span>{data.ami_deployment_pct?.toFixed(1)}%</span>
            </div>
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-blue-500 rounded-full transition-all duration-300"
                style={{ width: `${Math.min(100, data.ami_deployment_pct || 0)}%` }}
              />
            </div>
          </div>
        </div>
      )}

      {/* Explanation */}
      <div className="mt-3 p-2 bg-gray-50 rounded text-xs text-gray-500">
        <strong>AMI</strong>: Advanced Metering Infrastructure enables two-way communication,
        real-time usage data, remote monitoring, and faster outage detection.
      </div>

      {/* Trend chart */}
      <div className="mt-3 pt-3 border-t border-gray-100">
        <h4 className="text-xs font-medium text-gray-500 uppercase">AMI Deployment Trend</h4>
        <TrendChart
          utilityData={utilityData}
          metricPath="infrastructure.ami_deployment_pct"
          selectedYear={selectedYear}
          label="AMI Deployment"
          unit="%"
          color="#10b981"
          lowerIsBetter={false}
        />
      </div>

      {/* Data source */}
      <div className="text-xs text-gray-400 mt-3 pt-2 border-t border-gray-100">
        Source: EIA-861 Advanced Metering Infrastructure
      </div>
    </SectionContainer>
  );
}

export default InfrastructureSection;
